module.exports = "/static/assets/7c3cee97eda772af1d4585b4c684bcc4.png";